module.exports = __webpack_public_path__ + "assets/roboto-medium.92d0e5c360e20872dd987120dece02f4f3a8fa3ec2f32b4de3ce9e63dde0d6f9.woff";